module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/is-vux-wechat-official-project-20.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/is-vux-wechat-official-project.md
// module id = 593
// module chunks = 429